// Duplicated from ab-common
import { useCallback } from 'react';
import { useReactRedux } from '@applyboard/ab-common';
function useReduxDispatcher(dispatcher) {
  var mapDispatchToProps = useCallback(function (dispatch) {
    return {
      data: function data() {
        return dispatch(dispatcher.apply(void 0, arguments));
      }
    };
  }, [dispatcher]);
  var _useReactRedux = useReactRedux(null, mapDispatchToProps),
    data = _useReactRedux.data;
  return data;
}
export default useReduxDispatcher;